import React, { Component } from "react";

import { Row, Col, Card, CardBody, FormGroup, Button,  Label, Container, Spinner } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { BaseUrl } from "../../../helpers/Baseurl"


class AddSignature extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      breadcrumbItems: [
        { title: "Signatures", link: "/signatures" },
        { title: "Add New Signature", link: "#" },
      ],
    };
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
  }
	

    this.handleSubmit = this.handleSubmit.bind(this);    

  }

  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")
    this.props.history.push('/signatures')
  }
  
  handleSubmit(e, values) {
    this.setState({ loading: true })
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values)
        };
        fetch(`${BaseUrl}/api/cms/signatures/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "---data")
                            toastr.error("Something Went Wrong", "") 
                            this.setState({ loading: false })
                          }
                            
                      )
                  }
                  else{
                    toastr.success(`Signature Added Successfully`, "") 
                    this.props.history.push('/signatures')
                  }    
              }
          )

  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="Add New Signature" breadcrumbItems={this.state.breadcrumbItems} />
            <AvForm className="needs-validation" onValidSubmit={this.handleSubmit} >
              <Row>
                <Col xl="6">
                  <Card>
                    <CardBody>
                      <Row>
                          <Col md="6">
                              <div className="mb-3">
                              <Label className="form-label " htmlFor="name">Name</Label>
                              <AvField
                                  name="name"
                                  placeholder="Name"
                                  type="text"
                                  errorMessage="Enter Itinerary Name"
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  id="name"
                                  
                              />
                              </div>
                          </Col> 
                          <Col md="6">
                              <div className="mb-3">
                              <Label className="form-label " htmlFor="customer_name">Designation</Label>
                              <AvField
                                  name="designation"
                                  placeholder="Designation"
                                  type="text"
                                  errorMessage="Enter Customer Name"
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  id="designation"
                                  
                              />
                              </div>
                          </Col> 
                      </Row>

                      <Row>
                          <Col md={6}>
                              <div className="mb-3">
                                  <AvField
                                      name="phone"
                                      label="Contact Number"
                                      placeholder="Contact Number"
                                      type="text"
                                      errorMessage="Enter Only Digits"
                                      validate={{
                                          required: { value: true },
                                      }}
                                      />
                              </div>
                          </Col>
                          <Col md="6">
                              <div className="mb-3">
                              <Label className="form-label " htmlFor="email">Email</Label>
                              <AvField
                                  name="email"
                                  placeholder="Customer Email"
                                  type="email"
                                  errorMessage="Enter Customer Name"
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  id="email"
                                  
                              />
                              </div>
                          </Col> 
                      </Row>
                      <Row>
                          <Col md="12">
                              <div className="mb-3">
                              <Label className="form-label " htmlFor="address">Address</Label>
                              <AvField
                                  name="address"
                                  placeholder="Customer Address"
                                  type="text"
                                  errorMessage="Enter Address"
                                  className="form-control"
                                  id="address"
                                  
                              />
                              </div>
                          </Col> 
                      </Row>
                      <Row>
                          <Col md="12">
                              <div className="mb-3">
                              <Label className="form-label " htmlFor="website">Website</Label>
                              <AvField
                                  name="website"
                                  placeholder="Website"
                                  type="text"
                                  errorMessage="Enter Website"
                                  className="form-control"
                                  id="website"
                                  
                              />
                              </div>
                          </Col> 
                      </Row>
                                          
                        <FormGroup className="mb-0">
                          {this.state.loading?(
                            <Spinner className="me-2 mt-2" color="primary" />
                          ):(
                            <div>
                        
                          <Button type="submit" color="primary" className="me-1">
                            Submit
                        </Button>{" "}
                          <Button type="button" onClick={() => this.props.history.goBack()} color="secondary">
                            Cancel
                        </Button>
                        </div>
                          )}
                        
                        
                      </FormGroup>      

                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </AvForm>

          </Container>
        </div>
       
      </React.Fragment>
    );
  }
}

export default AddSignature;



    